export default __webpack_public_path__ + "static/media/O-084.b134f3da.png";